<template>
  <div class="alert-subsection">
    <div class="alert-subsection-header d-flex align-items-center" @click="$emit('toggle')">
      <span class="alert-chevron alert-chevron-sm mr-2" :class="{ open: visible }">&#9654;</span>
      <span class="alert-subsection-title">{{ label }}</span>
    </div>
    <b-collapse :visible="visible">
      <table width="100%" class="alert-settings-table" cellpadding="8">
        <slot></slot>
      </table>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'SubsectionGroup',
  props: {
    label: { type: String, required: true },
    visible: { type: Boolean, default: false },
  },
}
</script>

<style>
.alert-subsection {
  margin-top: 4px;
}
.alert-subsection:first-child {
  margin-top: 0;
}
.alert-subsection-header {
  cursor: pointer;
  user-select: none;
  padding: 10px 4px 4px;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-top: 1px solid #eee;
}
.alert-subsection:first-child .alert-subsection-header {
  border-top: none;
  padding-top: 0;
}
.alert-subsection-header:hover {
  color: #333;
}
.alert-subsection-title {
  color: #6c757d;
}
.alert-chevron-sm {
  font-size: 10px;
}
</style>
